




import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { RenderMenuMixin } from '@/mixins';
import { AcgnApproveDetail, AcgnStaticsMenu } from '@/components';

@Component({
  components: {
    AcgnApproveDetail,
    AcgnStaticsMenu
  },
  mixins: [RenderMenuMixin]
})

/**
 * 项目数据-审批明细（项目-成员创作方也是此页面）
 */
export default class StatisticApproveDetail extends Vue {

  private comicId: number; // 漫画id
  private userId: number | null = null; // 用户id

  private created() {
    const { id, userid } = this.$route.params;
    this.comicId = parseInt(id, 10);
    if (userid) {
      this.userId = parseInt(userid, 10);
    }
  }

  // 渲染左侧菜单
  private renderMenu() {
    return (
      <acgn-statics-menu type="comic" comicId={this.comicId}></acgn-statics-menu>
    );
  }
}
